import React from 'react';

import { GlobalStateContext, DispatchStateContext } from 'Providers/GlobalStateProvider';

const useGlobalState = () => [React.useContext(GlobalStateContext), React.useContext(DispatchStateContext)];

export default useGlobalState;